import { CartItem } from './cartItem';
import { Participant } from './participant';
import { Person } from './person';

export class Order {
    public user?: Person;
    public billing?: Person;
    public participants?: Participant[];
    public cartItems?: CartItem[];
    public totalPrice?: number;
    public requestCreated?: boolean;
    public sameAsBookingContact?: true;
    public isGroupBooking? = false;

    constructor(data) {
        this.user = data.user || null;
        this.billing = data.billing || null;
        this.participants = data.participants || null;
        this.cartItems = data.cartItems || null;
        this.totalPrice = data.totalPrice || null;
        this.requestCreated = data.requestCreated || null;
        this.sameAsBookingContact = data.sameAsBookingContact || null;
        this.isGroupBooking = data.isGroupBooking || null;
    }
}
